import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'
import rootReducer from './rootReducer'

import { encryptTransform } from 'redux-persist-transform-encrypt'

export const persistedReducers = persistReducer(
    {
        key: 'treepay',
        storage,
        transforms: [
            encryptTransform({
                secretKey: 'chave-secreta',
                onError: function (error) {},
            }),
        ],
        whitelist: ['auth', 'menu'],
    },
    rootReducer
)
